import React from 'react';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { useLoginContext } from '../../Contexts/LoginContext';
import { TbChevronRight, TbInfoCircle } from 'react-icons/tb';
import { RiCoinsFill } from 'react-icons/ri';
import Badge from './Badge';
import { formatCurrency } from '../../Utils/Formatters';
import { useTranslation } from 'react-i18next';

interface MainMenuItemFidelityProps {
    show?: boolean;
    onClick?: CallableFunction;
}
const MainMenuItemFidelity = ({ show=true, onClick=() => {} }: MainMenuItemFidelityProps) => {
    const { company } = useLayoutContext();
    const { t } = useTranslation();
    const currencyName = company?.fidelity?.currency_name || "Pontos";
    const { user } = useLoginContext();
    const availablePoints = Number(user?.all_points ?? (typeof user?.fidelity_points === 'number' ? user?.fidelity_points : 0));
    const availableBalance = availablePoints * company.fidelity.point_value;

    if (!show) return null;

    return (
        <div onClick={() => onClick?.()} className="w-full flex flex-col bg-custom-primary text-white rounded-xl px-4 py-3 shadow-lg transition-all mb-2 divide-y divide-white/20 cursor-pointer">
            <div className='flex items-center md:items-center justify-between pb-2 gap-2'>
                <div className="flex flex-col w-full">
                    <h3 className="text-xl font-bold">{t('layout.fidelity.balance_title')}</h3>
                    <div className="flex items-center">
                        <RiCoinsFill className="text-white text-4xl md:text-3xl" />
                        <span className="text-4xl font-bold leading-none fadeInIcon">{availablePoints}</span>
                        <div className="flex gap-1.5 items-center fadeInIcon">
                            <Badge outline className="ml-1.5 text-sm px-2 rounded-full text-white opacity-75 ring-white/30 normal-case">
                                {currencyName}
                            </Badge>
                            <span className="text-xs leading-none opacity-75 fadeInIcon">{formatCurrency(availableBalance)}</span>
                        </div>
                    </div>
                </div>

                <div className="flex justify-center md:w-fit">
                    <TbChevronRight size={40} className="opacity-45" />
                </div>
            </div>
            <div className='pt-2 text-sm leading-none flex items-center gap-1 opacity-85'>
                <div><TbInfoCircle size={20} /></div>
                <div className='flex flex-col'>
                    <strong>{t('layout.fidelity.how_to_use')}</strong>
                    <span className='opacity-60'>{t('layout.fidelity.how_to_use_message')}</span>
                </div>
            </div>
        </div>
    )
}

export default MainMenuItemFidelity;